module.exports = __webpack_public_path__ + "static/media/c17d3431.jpg";